import React from 'react';

import IconType from '../../../types/Icon';

const Time: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9 1V3H15V1H9ZM18.959 2.79297L17.666 4.31836L20.6152 6.81836L21.9082 5.29297L18.959 2.79297ZM12 4C7.02255 4 3 8.02255 3 13C3 17.9775 7.02255 22 12 22C16.9775 22 21 17.9775 21 13C21 8.02255 16.9775 4 12 4ZM12 6C15.9105 6 19 9.08945 19 13C19 16.9105 15.9105 20 12 20C8.08945 20 5 16.9105 5 13C5 9.08945 8.08945 6 12 6ZM11 8V14H13V8H11Z"
				fill={color}
			/>
		</svg>
	);
};

export default Time;
